import { FC } from "react";

import ListagemUsuarioComponent from "../usuario/listagemUsuarioComponent";

const HomeTeste: FC = () => {
  return <ListagemUsuarioComponent tipoUsuario="TESTE" />;
};

export default HomeTeste;
